import type { PropsWithChildren } from 'react';
import { useRef } from 'react';

import { Provider } from 'react-redux';

import type { TAppStore } from '@/store';
import { makeStore } from '@/store';

export const StoreProvider = ({ children }: PropsWithChildren) => {
  const storeRef = useRef<TAppStore>(undefined);

  if (!storeRef.current) {
    storeRef.current = makeStore();
  }

  return <Provider store={storeRef.current}>{children}</Provider>;
};
